import { render, staticRenderFns } from "./EnfoldCD.vue?vue&type=template&id=4689e2d5&scoped=true"
var script = {}
import style0 from "./EnfoldCD.vue?vue&type=style&index=0&id=4689e2d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4689e2d5",
  null
  
)

export default component.exports